
            // Dummy implementation of next-themes

            // useTheme hook that returns system theme
            const useTheme = () => {
              return { theme: "system" };
            };

            // ThemeProvider component (dummy React component)
            const ThemeProvider = ({ children, ...props }) => {
              console.log('[Shakespeare next-themes Mock] ThemeProvider rendered:', props);
              return children;
            };

            // Export both named and default exports to match next-themes API
            export { useTheme, ThemeProvider };
          